import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/lib/utils';

export interface ThemeToggleProps {
  /** `light` when placed on the dark side panel. */
  tone?: 'light' | 'dark';
  className?: string;
}

export function ThemeToggle({ tone = 'dark', className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${nextTheme} theme`}
      title={`Switch to ${nextTheme} theme`}
      className={cn(
        'grid h-9 w-9 place-items-center rounded-field border transition-colors',
        tone === 'light'
          ? 'border-white/15 text-[#9BABA6] hover:border-white/30 hover:text-white'
          : 'border-accent hover:border-accent hover:text-accent',
        className,
      )}
    >
      {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
